import { render, staticRenderFns } from "./CommentaryMainTab.vue?vue&type=template&id=b1244eca&scoped=true"
import script from "./CommentaryMainTab.vue?vue&type=script&lang=js"
export * from "./CommentaryMainTab.vue?vue&type=script&lang=js"
import style0 from "./CommentaryMainTab.vue?vue&type=style&index=0&id=b1244eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1244eca",
  null
  
)

export default component.exports